export default __webpack_public_path__ + "static/media/BGTrovityLogo.8a22a09c.svg";